// extracted by mini-css-extract-plugin
export var button = "button-close-module--button--PejWF";
export var icon = "button-close-module--icon--glml3";